<template>
    <div>
        <el-form :inline="true" :model="form" >
            <el-form-item label="关键字">
                <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="category">
                <el-cascader style='width: 200px' ref='category' :props="category" clearable v-model="categoryObj" :show-all-levels="false" props.checkStrictly=true
                             @change="showSelect"
                >
                    <template slot-scope="{ node, data }">
                        <span>{{ data.label }}</span>
                    </template>
                </el-cascader>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
        </el-form>
        <div>
            <el-table v-if="!radioCheck" :data="tableData" v-loading="loading"  @selection-change="handleSelectionChange">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="配置项编号" prop="serialNumber"></el-table-column>
                <el-table-column label="配置项名称" prop="title"></el-table-column>
                <el-table-column label="配置项分类" prop="category"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
            </el-table>
            <el-table v-if="radioCheck" :data="tableData" v-loading="loading"  @current-change="currentRowChange">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column type="index" width="55"></el-table-column> -->
                <el-table-column label="配置项编号" prop="serialNumber"></el-table-column>
                <el-table-column label="配置项名称" prop="title"></el-table-column>
                <el-table-column label="配置项分类" prop="category"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
        <div style="margin:70px 0 10px 0;display: flex;">
            <el-button type="primary" size="small" @click="submit">确定</el-button>
            <el-button type="default" size="small" @click="onCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import services from "../../services/common.service"
    import sendServices from '../configuration/configuration.services'
    export default {
        props:{
            callback:Function,
            radioCheck:Boolean,
        },
        data() {
            return {
                tableData:[],
                loading:true,
                form:{
                    pageIndex:1,
                    pageSize:10,
                    keyword:""
                },
                multipleSelection: [],
                total:null,
                categoryObj:{},
                category: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad: (node, resolve) => this.categoryLazyLoad(node, resolve)
                },
            }
        },
        created() {
            // console.log(this.radioCheck)
            this.request();
        },
        methods: {
            showSelect(obj){
                // this.showConfigPros=false
                obj[0] ? this.form.category = obj[obj.length-1].id : this.form.category = null
                // console.log(this.form.category,'this.ruleForm.category');
                // let getCategory=this.form.category[this.form.category.length-1]
                // if (getCategory&&getCategory.title.indexOf('服务器')>-1){
                //             this.showConfigPros=true
                // }
            },
            // 分类懒加载请求
            categoryLazyLoad(node, resolve) {
                if (!node.level) {
                    sendServices.typeList({ type: 11 }).then(res => {
                    let newArr = res.map(item => {
                        return {
                        leaf: !item.hasChildren,
                        value: item,
                        label: item.title
                        };
                    });
                    resolve(newArr);
                    });
                } else {
                    sendServices.childrenList({ parentId: node.value.id }).then(res => {
                    let newArr = res.map(item => ({
                        leaf: !item.hasChildren,
                        value: item,
                        label: item.title
                        }));
                    resolve(newArr);
                    });
                }
            },
            loadData(){
                this.form.pageIndex=1
                this.request()
            },
            request(){
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                services.getConfigList(this.form).then(res => {
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            currentRowChange(val){
                this.multipleSelection[0] = val
                this.callback(this.multipleSelection);
                this.$modal.close();
            },
            submit(){
                if(this.multipleSelection.length == 0){
                    this.$message.error("请至少选择一个")
                }else{
                    this.callback(this.multipleSelection);
                    this.$modal.close();
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },

            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
